/**
 * Admin Dashboard (/admin index)
 * ADMIN-HOME-001 (Jun 2026): admins now land on the TitleFlow Admin
 * Dashboard (central portal). Non-admin roles that reach /admin keep the
 * legacy redirect to the operational dashboard.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserFromToken } from '../utils/adminApi';
import AdminHomePage from './admin/AdminHomePage';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const user = getUserFromToken();
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) {
    return (
      <div className="admin-placeholder">
        <p>Redirecting to dashboard...</p>
      </div>
    );
  }

  return <AdminHomePage />;
};

export default AdminDashboard;
